module.exports = __webpack_public_path__ + "static/img/stennis.9507257.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/stennis.png
// module id = 2bcY
// module chunks = 0